export default __webpack_public_path__ + "static/media/storx-logo-light.6c530852.svg";